'use strict';
import $ from 'jquery';
import Cookies from 'js-cookie';

export default class HeaderBanner {
    COOKIE_NAME = 'hide-ontinue-header-banner';

    static init() {
        $('.header-banner').each((index, el) => {
            new HeaderBanner($(el));
        });
    }

    constructor($el) {
        this.el = $el;
        if (!Cookies.get(this.COOKIE_NAME)) {
            this.showBanner();
        }
        this.el.on('click', '.header-banner-close', (e) => {
            e.preventDefault();
            Cookies.set(this.COOKIE_NAME, '1', { expires: 30 });
            this.hideBanner();
        });
    }

    showBanner() {
        this.el.slideDown(this.setHeaderHeight.bind(this));
    }

    hideBanner() {
        this.el.slideUp(() => {
            this.setHeaderHeight();
            $('body').removeClass('header-banner-enabled');
        });
    }

    setHeaderHeight() {
        const header = $('#header');
        const root = document.documentElement;

        const stickyHeight = header.outerHeight();
        root.style.setProperty('--header-height', stickyHeight + 'px');
    }
}